import { render, staticRenderFns } from "./Apps.template.vue?vue&type=template&id=2831859c&scoped=true&"
var script = {}
import style0 from "./Apps.template.vue?vue&type=style&index=0&id=2831859c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2831859c",
  null
  
)

export default component.exports